export class InvalidExerciseData extends Error {

}
